module.exports = __webpack_public_path__ + "static/img/7725_phase_function_Paper_Points.5455555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7725_phase_function_Paper_Points.png
// module id = fdlq
// module chunks = 0